import { Component, computed, EventEmitter, Input, OnChanges, OnInit, Output, Signal, signal, SimpleChanges, WritableSignal } from '@angular/core';
import { CompaniesWithStoreStocks, CompanyWithStoreStocks, StockCounters, StoreStock, StoreStocks } from 'src/app/models/types/Product/Stock.type';
import { SharedModule } from 'src/app/modules/shared.module';
import { StockAndPriceService } from 'src/app/services/api/stock-and-price.service';
import { SharedService } from 'src/app/services/shared.service';
import { MyStoreStockComponent } from '../my-store-stock/my-store-stock.component';
import { StockButtonComponent } from '../stock-button/stock-button.component';
import { PdpService } from '../../pdp.service';

@Component({
  selector: 'app-hq-stock',
  imports: [
    MyStoreStockComponent,
    StockButtonComponent,
    SharedModule
  ],
  templateUrl: './hq-stock.component.html',
  styleUrl: './hq-stock.component.scss'
})
export class HqStockComponent implements OnChanges {

  @Input('sapCode') sapCode!: string;
  @Input('hqStock') hqStock!: CompaniesWithStoreStocks;
  @Input('selectedArea') selectedArea: string | null = null;

  @Output('handleGoBackToAreaList') handleGoBackToAreaList: EventEmitter<void> = new EventEmitter<void>();

  private _companies: WritableSignal<CompaniesWithStoreStocks | null> = signal(null);
  public companies: Signal<CompaniesWithStoreStocks | null> = computed(() => this._companies());

  private _selectedCompany: WritableSignal<CompanyWithStoreStocks | null> = signal(null);
  public selectedCompany: Signal<CompanyWithStoreStocks | null> = computed(() => this._selectedCompany());

  public stores: Signal<StoreStocks> = computed(() => {
    let selectedCompany = this._selectedCompany();
    if (selectedCompany && selectedCompany.storeStocks) {
      return selectedCompany.storeStocks.find(val => val.sapcode === this.sapCode)?.storeStocks || [];
    }
    return []
  });

  public total: Signal<StockCounters> = computed(() => {
    let stocks = this.stores();
    return this.stockAndPriceService.getStoreStockCounterTotal(stocks);
  });

  private _selectedStore: WritableSignal<StoreStock | null> = signal(null);
  public selectedStore: Signal<StoreStock | null> = computed(() => this._selectedStore());

  //Flag che determina quando devo mostrare l'elenco delle companies
  public get showCompanyList(): boolean {
    //Mostro le companies quando non ne ho ancora selezionata una
    return !this.selectedCompany();
  }

  //Flag che determina quando devo mostrare l'elenco degli store
  public get showStoreList(): boolean {
    //Mostro glis tore quando ho selezionato una company ma non ho ancora selezionato uno store
    return !!this.selectedCompany() && !this.selectedStore();
  }

  //Flag che determina quando devo mostrare lo stock dello store selezionato
  public get showStoreStock(): boolean {
    return !!this.selectedStore();
  }

  constructor(
    public readonly pdpService: PdpService,
    public readonly sharedService: SharedService,
    public readonly stockAndPriceService: StockAndPriceService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.buildCompanies(this.sapCode);
  }

  /**
   * Costruisco l'array delle companies in modo che abbia solo gli store che contengono il sapcode
   * passato come parametro.
   * @param sapCode
   */
  buildCompanies(sapCode: string) {
    let selectedCompany: CompanyWithStoreStocks | null = this._selectedCompany();
    let companies: CompaniesWithStoreStocks = [];
    (JSON.parse(JSON.stringify(this.hqStock)) as CompaniesWithStoreStocks).forEach(company => {
      // let stores = company.storeStocks?.find(val => val.sapcode === sapCode);
      // if (stores) {
      //   company.storeStocks = [stores];
      // }
      companies.push(company);
    });
    this._companies.set(companies);
    this.handleSelectCompany(null);
    this.handleSelectCompany(selectedCompany);
    setTimeout(() => {
      let selectedStore = this._selectedStore();
      this.handleSelectStore(null);
      this.handleSelectStore(selectedStore);
    }, 100);
  }

  handleSelectCompany(company: CompanyWithStoreStocks | null) {
    this._selectedCompany.set(company);
    if (this.pdpService.showGlobaAreaSizes) {
      if (this.pdpService.initializedGlobalAreaStock) {
        this.pdpService.updateSizeCounters_forCompany(company)
      }
    } else {
      this.pdpService.updateSizeCountersForHqUser(company)
    }
  }

  handleSelectStore(storeStock: StoreStock | null) {
    this._selectedStore.set(storeStock);
    if (this.pdpService.showGlobaAreaSizes) {
      if (storeStock === null) {
        this.pdpService.resetSizeCounters();
        this.handleSelectCompany(this._selectedCompany())
      } else {
        if (this.pdpService.initializedGlobalAreaStock) {
          this.pdpService.updateSizeCounters_forStore(this.selectedCompany()!.storeStocks || null, storeStock.store!);
        }
      }
    } else {
      this.pdpService.updateSizeCountersForHqUser(this._selectedCompany(), storeStock)
    }
  }

}
